export interface SearchState {
  destination: string;
  month: string;
  diver: number;
  currentYear: number;
  currentStage: number;
  searchType: number;
  destinationId: number;
  monthId: number;
}

export type SearchAction =
  | { type: 'SET_DESTINATION'; payload: string }
  | { type: 'SET_MONTH'; payload: string }
  | { type: 'SET_DIVER'; payload: number }
  | { type: 'SET_CURRENT_YEAR'; payload: number }
  | { type: 'SET_CURRENT_STAGE'; payload: number }
  | { type: 'SET_SEARCH_TYPE'; payload: number }
  | { type: 'SET_DESTINATION_ID'; payload: number }
  | { type: 'SET_MONTH_ID'; payload: number };

export const searchInitialState: SearchState = {
  destination: 'Anywhere',
  month: 'Anytime',
  diver: 1,
  currentYear: new Date().getFullYear(),
  currentStage: 0,
  searchType: 0,
  destinationId: 0,
  monthId: 0,
};

export const searchReducer = (
  state: SearchState,
  action: SearchAction,
): SearchState => {
  switch (action.type) {
    case 'SET_DESTINATION':
      return { ...state, destination: action.payload };
    case 'SET_MONTH':
      return { ...state, month: action.payload };
    case 'SET_DIVER':
      return { ...state, diver: action.payload };
    case 'SET_CURRENT_YEAR':
      return { ...state, currentYear: action.payload };
    case 'SET_CURRENT_STAGE':
      return { ...state, currentStage: action.payload };
    case 'SET_SEARCH_TYPE':
      return { ...state, searchType: action.payload };
    case 'SET_DESTINATION_ID':
      return { ...state, destinationId: action.payload };
    case 'SET_MONTH_ID':
      return { ...state, monthId: action.payload };
    default:
      return state;
  }
};
